import Colors from 'assets/Colors';

function HamburgerHeaderIcon({
  size = '16',
  style = {},
  color = Colors.text_primary,
}) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 16 14"
      fill="none"
    >
      <path
        d="M9.85686 8.24944L1.28544 8.24944C1.20687 8.24944 1.14258 8.31373 1.14258 8.3923L1.14258 9.3923C1.14258 9.47087 1.20686 9.53516 1.28544 9.53516L9.85686 9.53516C9.93544 9.53516 9.99972 9.47087 9.99972 9.3923L9.99972 8.3923C9.99972 8.31373 9.93544 8.24944 9.85686 8.24944ZM9.99972 4.60658C9.99972 4.52801 9.93544 4.46373 9.85686 4.46373L1.28544 4.46373C1.20687 4.46373 1.14258 4.52801 1.14258 4.60658L1.14258 5.60658C1.14258 5.68516 1.20687 5.74944 1.28544 5.74944L9.85686 5.74944C9.93544 5.74944 9.99972 5.68516 9.99972 5.60658L9.99972 4.60658ZM0.999722 13.2852L14.9997 13.2852C15.0783 13.2852 15.1426 13.2209 15.1426 13.1423L15.1426 12.1423C15.1426 12.0637 15.0783 11.9994 14.9997 11.9994L0.999722 11.9994C0.921151 11.9994 0.856865 12.0637 0.856865 12.1423L0.856865 13.1423C0.856865 13.2209 0.92115 13.2852 0.999722 13.2852ZM0.999723 1.99944L14.9997 1.99944C15.0783 1.99944 15.1426 1.93516 15.1426 1.85659L15.1426 0.856586C15.1426 0.778014 15.0783 0.713728 14.9997 0.713728L0.999723 0.713727C0.921151 0.713727 0.856866 0.778013 0.856866 0.856584L0.856866 1.85658C0.856866 1.93516 0.921151 1.99944 0.999723 1.99944ZM15.0819 6.87623L12.2908 4.67801C12.1872 4.59587 12.0337 4.66909 12.0337 4.80123L12.0336 9.19766C12.0336 9.3298 12.1854 9.40301 12.2908 9.32087L15.0819 7.12266C15.1006 7.10807 15.1158 7.08938 15.1263 7.06803C15.1367 7.04667 15.1421 7.02321 15.1421 6.99944C15.1421 6.97567 15.1367 6.95221 15.1263 6.93086C15.1158 6.9095 15.1006 6.89082 15.0819 6.87623V6.87623Z"
        fill={color}
      />
    </svg>
  );
}

export default HamburgerHeaderIcon;
